<template>

  <aicc-page :pageId="this.contextPageId" :titleShow="false">
    <ur-area>

  <!-- <ur-modal ref="calleeDetailModel" title="수신리스트 상세보기" xlarge> -->

      <div class="pop_header">
        <p class="pop_title">수신리스트 상세</p>
      </div>

      <div>
        <span>캠페인 이름 {{this.outCallSchedule.scheduleName}} </span>
        <ur-data-grid style="min-width: 1184px;" :headers="calleeHeaders" :options="calleeoptions" :data-source="calleeItems" ref="calleeGrid">
          <template #right-info>
              <ur-button @click="clearParam" small>필터 초기화</ur-button>
          </template>
        </ur-data-grid>
        <ur-button @click="closePopup" main style="float: right;">확인</ur-button>
      </div>

    <!-- <template slot="action">
      <ur-button @click="close" main>확인</ur-button>
    </template> -->
  <!-- </ur-modal> -->

    </ur-area>
  </aicc-page>
</template>

<script>
import BasePage from '~cm/components/BasePage';
import {urDataSet} from 'uidev-component/index.js';
import urDataGrid from '@uidev/grid/urDataGrid/urDataGrid';

export default {
  name: 'PGE_AIC_00015', // eslint-disable-line vue/name-property-casing
  extends: BasePage,
  
  components: {
    BasePage,
    urDataGrid,
  }, 

  props: {
    // onCloseCalleePopup: {
    //   type: Function,
    //   default: () => {},
    // },
    // calleeInfoList: {
    //   type: Array, 
    //   default: () => [],
    // },
    // scenarioVariables: {
    //   type: Array, 
    //   default: () => [],
    // },
    // outCallSchedule: {
    //   type: Object,
    //   default: null,
    // },
  },
  data() {
    return {
      dataSet : new urDataSet(),
      calleeoptions: {
        height: 400,
        msgTotal: "총 #",
        msgAscending   : '오름차순 정렬',
        msgDescending  : '내림차순 정렬',
        msgEmptyData : '',
      },

      calleeItems : [],
      calleeHeadersBase : [
        // {value:'__idx',text:'#', width: 40},
        {value:'columnIndex', text:'#', edit:false, readonly:true, width: 40},
        {value:'calleeId', text: this.$t('MSG_TXT_CALLEE_ID'), width: 80, sort: true, filter: true },
        {value:'itemIndex', hide:true, text:'#', edit:false, readonly:true, width: 40},
        {value:'calleeNumber', text: this.$t('MSG_TXT_CALLEE_NUMBER1'), width: 200, key:true, sort: true, filter:true},
        {value:'reservationDate', text: this.$t('MSG_TXT_RESERVATION_DATE'), width: 100, sort: true, filter:true},
        {value:'reservationTime', text: this.$t('MSG_TXT_RESERVATION_TIME'), width: 100, sort: true, filter:true},
        {value:'runScriptOrder', text: '대화ID 순서', width: 200, sort: true, filter:true},
        {value:'customerId', text: '고객ID', width: 200, sort: true, filter:true},
      ],
      calleeHeaders: [],
      calleeCustomColumns: [],

      outCallScheduleAsk: {
        scheduleId: '',
      },

      scheduleId: '',
      outCallSchedule: {
        scheduleId: '',
        scheduleName: '',
      },

    };
  },
 
  computed: {

  },
 
  watch: {

  },
 
  created() {
    this.scheduleId = utils.getParameter(this, 'scheduleId');
  },

  mounted() {
    this.calleeoptions.height = $(".ur-area").css("height").replace("px","")-120;
    this.getSchedule();    
  },
 
  beforeUpdate() {

  },
 
  updated() {

  },
 
  beforeDestroy() {
    
  },
 
  destroyed() {
    
  },
 
  methods: {

    getSchedule() {
      // OutCall Schedule 한 건 가져온다.
      this.outCallScheduleAsk.scheduleId = this.scheduleId;
      http.request(this.contextPageId, 'DTS_AIC_00005', {
        query: this.outCallScheduleAsk,
      }).then((response) => {
        // console.log(JSON.stringify(response.data))

        this.outCallSchedule = response.data;
        // 시나리오 variables로 부터 custom 컬럼을 채운다.
        // this.getScenarioVariable(this.outCallSchedule.scenarioId);
        this.outCallSchedule.scenarioVariables = [];
        for (var variable of response.data.scenarioVariableList) {
          this.outCallSchedule.scenarioVariables.push({"value": variable.variableName, "text": variable.variableMeaning});
        }
        this.openPopup();

      }).catch((error) => {
        console.warm(error);
      });        
    },

    openPopup(){
      this.calleeHeaders = this.calleeHeadersBase.slice();
      this.$refs['calleeGrid'].setHeaders(this.calleeHeaders);
      // this.calleeoptions.msgEmptyData = '선택하신 조건의 조회결과가 없습니다.';
      this.calleeoptions.msgEmptyData = '';
      this.$refs['calleeGrid'].updateOptions(this.calleeOptions);
      this.setCalleeList();
      // this.$refs['calleeDetailModel'].open();
    },

    closePopup(){
      // this.$refs['calleeDetailModel'].close();
      window.close();
    },

    setCalleeList() {
      // console.log(JSON.stringify(this.outCallSchedule.scenarioVariables))
      this.calleeCustomColumns = [];
      if (!utils.isEmpty(this.outCallSchedule.scenarioVariables)) {
        for(let column of this.outCallSchedule.scenarioVariables) {
          column.sort = true;
          column.filter = true;
          this.calleeHeaders.push(column);
          this.calleeCustomColumns.push(column.value);
        }
      }

      // console.log(JSON.stringify(this.outCallSchedule.outCalleeInfoList))
      this.calleeItems = [];
      let idx = 1;
      for (var callee of this.outCallSchedule.outCalleeInfoList) {
        let row = {};
        row.itemIndex = callee.itemIndex;
        // row.calleeNumber = callee.calleeNumber.replace(/(^02.{0}|^01.{1}|[0-9]{3})([0-9]+)([0-9]{4})/,"$1-$2-$3");
        row.calleeNumber = callee.calleeNumber;
        if (!utils.isEmpty(callee.reservationDate)) {
          row.reservationDate = utils.toStringByFormat(utils.toDate(callee.reservationDate), 'YYYY-MM-DD')
        }  
        if (!utils.isEmpty(callee.reservationTime)) {
          row.reservationTime = callee.reservationTime.substr(0,2)+':'+callee.reservationTime.substr(2,2);
        } 

        if (!utils.isEmpty(callee.outcallData)) {          
          let outcallData = JSON.parse(callee.outcallData);
          row.runScriptOrder = outcallData['__runScriptOrder'];
          utils.forEach(this.calleeCustomColumns, customColumns => {
            row[customColumns] = outcallData[customColumns]; 
          });
        }
        row.columnIndex = idx++;
        // item_index를 정해진 수신ID 포맷으로 변환
        row.calleeId = aiccUtils.stringUtil.itemIndexToCalleeId(callee.itemIndex);
        row.customerId = callee.customerId;
        this.calleeItems.push(row);
      }
      if (this.calleeItems.length === 0) {
        this.calleeoptions.msgEmptyData = '선택하신 조건의 조회결과가 없습니다.';
        this.$refs['calleeGrid'].updateOptions(this.calleeOptions);
      }
    },

    clearParam() {
      this.$refs['calleeGrid'].clearFilter();
      this.$refs['calleeGrid'].clearSort();
    },

  },
};
</script>

<style>

</style>